import { Helmet } from 'react-helmet';
import {
    Avatar,
    Box, Button, Card, CardContent, InputAdornment, IconButton,
    Container, Divider,
    Grid, Tab, Tabs, Collapse, Typography, tableCellClasses, ClickAwayListener, TextField, FormGroup, FormControlLabel, Checkbox, Paper, Grow, Popper, MenuList
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import cssVariables from "../../../../theme/cssVariables";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Search from "@mui/icons-material/Search";
import { makeStyles, styled } from "@mui/styles";
import emty from "../../../../assets/images/emty.png";
import { ReactComponent as BtnFilter } from "../../../../assets/images/btn-filter.svg";
import { useParams } from "react-router-dom";
import { ReactComponent as DraftIcon } from "../../../../assets/images/iconStatus/draft.svg";
import { ReactComponent as ApprovedIcon } from "../../../../assets/images/iconStatus/approved.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/edit.svg";
import { ReactComponent as StartIcon } from "../../../../assets/images/start.svg";
import { ReactComponent as SaveIcon } from "../../../../assets/images/save.svg";
import { ReactComponent as CancelIcon } from "../../../../assets/images/cancel.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar-month.svg";
import { ReactComponent as InfoIcon } from "../../../../assets/icons/info.svg";
import { ReactComponent as TeamIcon } from "../../../../assets/images/people.svg";
import { ReactComponent as InnovationIcon } from "../../../../assets/images/position-icon.svg";
import { ReactComponent as ErrorIcon } from "../../../../assets/images/circle-fill-error.svg";
import { ReactComponent as Signoff } from "../../../../assets/images/signoff.svg";
import { ReactComponent as Megaphone } from "../../../../assets/images/megaphone.svg";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as TrashIcon } from "../../../../assets/icons/trash-alt.svg"
import { ReactComponent as Refresh } from "../../../../assets/icons/refresh.svg"
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as NodataPlsAdd } from "../../../../assets/icons/nodataPlsAdd.svg";
import { ReactComponent as FormIcon } from "../../../../assets/icons/form360.svg";
import DialogSendToApprove from "../../../../components/kpi/DialogSendToApprove";
import { ReactComponent as LaunchFormIcon } from "../../../../assets/icons/launchForm.svg";
import { tabsClasses } from '@mui/material/Tabs';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import Congrtulations from "../../../../components/kpi/Congrtulations";
import EvaluationRatio from "../../../../components/baseComponent/EvaluationRatio";
import TotalAchievements from "../../../../components/baseComponent/TotalAchievements";
import RatingSummary from "../../../../components/kpi/RatingSummary";
import Stack from '@mui/material/Stack';
import file from "../../../../assets/images/home/file.svg";
import signatures from "../../../../assets/images/home/signatures.svg";
import { ReactComponent as ChevronDown } from "../../../../assets/images/home/chevron-down.svg";
import { ReactComponent as ChevronUp } from "../../../../assets/images/home/chevron-up.svg";
import { ReactComponent as Checks } from "../../../../assets/icons/checks.svg";
import * as Util from "../../../../services/global.service";
import blockSignatures from "../../../../assets/images/signatures.svg";
import evaluateService from "../../../../services/evaluate.service";
import { ReactComponent as MoreInfoIcon } from "../../../../assets/images/more-info.svg";
import { ReactComponent as DateIcon } from "../../../../assets/images/date-work.svg";
import { object } from 'prop-types';
import { set } from 'date-fns';

const styles = {
    path: {
        color: "#68717A",
    },
    paDatasEvaluation: {
        marginTop: "-12px",
        marginLeft: "19px",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    lastToolBar: {
        marginTop: "0px",
    },
    blueBadge: {
        background: "rgba(93, 161, 150, 0.15)",
        padding: "5px 12px",
        color: "#5DA196",
        border: "1px solid #5DA196",
        borderRadius: "4px"
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    colorText: {
        color: "#404349",
        fontWeight: "400",
        paddingLeft: "10px"
    },
    box: {
        width: "calc(50% - 30px)",
        "flex-direction": "row",
        margin: "15px 15px",
    },
    content: {
        background: "#FFFFFF",
        boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
        padding: "17px 22px",
        height: "100%",
    },
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        backgroundColor: "#fff",
        height: "220px",
        boxShadow: "0px 0px 5px rgb(0 0 0 / 10%)",
        borderRadius: "10px",
        "justify-content": "center",
        "align-items": "center",
        marginBottom: "30px"
    },
    twoContent: {
        display: "flex",
        "justify-content": "center",
        "flex-direction": "row",
        "align-items": "center",
    },
    boxTwoContent: {
        display: "flex",
        "justify-content": "space-between",
        "flex-direction": "row",
        "align-items": "center",
    },
    trashIconSvg: {
        width: "24px",
        height: "24px",
        "& > path": {
            fill: "#CC6058",
        },
    },
    trashIconDisabledSvg: {
        width: "24px",
        height: "24px",
        "& > path": {
            fill: "#A3A3A3",
        },
    },
    paperContainer: {
        backgroundImage: `url(${blockSignatures})`,
        width: "100%",
        minHeight: 160,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "550px",
    },
};

const Manage360Evaluation = () => {
    const _ = require('lodash');
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    let { serial } = useParams();
    const [datePosition, setDatePosition] = React.useState("");
    const [dateEmpoloyee, setDateEmpoloyee] = React.useState("");
    const language = localStorage.getItem("lang");
    const [open, setOpen] = React.useState(false);
    const [openMenu, setOpenMenu] = React.useState(false);
    const [openMenus, setOpenMenus] = React.useState(false);
    const [openMenusCompetency, setOpenMenusCompetency] = React.useState(false);
    const [Datas, setData] = React.useState([]);
    const [mainDatas, setMainData] = React.useState([]);
    const [dataEvaluate, setDataEvaluate] = React.useState([]);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const [isConfirmResetDialogOpen, openConfirmResetDialog] = React.useState(false);
    const [isConfirmSaveDialogOpen, openConfirmSaveDialog] = React.useState(false);
    const [dataDel, setDataDel] = React.useState({});
    const [dataReset, setDataReset] = React.useState({});
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isSuccessResetDialogOpen, openSuccessResetDialog] = React.useState(false);
    const [openSuccessLaunchFormDialog, setOpenSuccessLaunchFormDialog] = React.useState(false);
    const [openSuccessSubmitDialog, setOpenSuccessSubmitDialog] = React.useState(false);
    const [search, setSearch] = React.useState("");

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
            fontSize: "14px"
        },
    }));

    useEffect(() => {
        getDetail()
        // dataRating()
    }, []);

    useEffect(() => {
        setDateWork()
    }, [dataEvaluate]);

    const getDetail = () => {
        evaluateService.getAdminManageEvaliation360Detail(serial).then(
            (rs) => {
                setData(rs?.data?.template_evaluator)
                setMainData(rs?.data?.template_evaluator)
                setDataEvaluate(rs?.data)
                // showError(rs?.data.evaluate_component, rs?.data,)
                // let getdata = Util.formatData(rs?.data?.evaluate_component, []).filter((rs) => Util.formatData(rs?.list_item, []).length > 0 && rs?.type !== "comment")
                // if (getdata.length > 0) {
                //     let getColor = Util.formatData(getdata[0]?.list_item, []).map((n) => Util.formatData(n?.options?.color, n?.color))
                //     setColor(getColor)
                // }
            }).catch(() => {

            })
    }

    const useStyles = makeStyles({
        iconContainer: {
            width: 48,
            height: 48,
            borderRadius: 5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        root: {
            'border-width': 0,
            'padding-left': 0,
            [`&.${tableCellClasses.body}`]: {
                'border-width': 0,
                'padding-left': 0,
            }
        },
        tab: {
            fontSize: "16px !important",
            fontWeight: "400 !important",
            '&.Mui-selected': {
                color: cssVariables.color.primary + " !important"
            },
            '&.MuiTab-root': {
                "text-transform": "none"
            }
        },
        profileContainer: {
            width: 70,
            height: 70,
            borderRadius: "50%",
            marginTop: 3,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        containerAchievements: {
            background: "#FAFAFA",
            border: "1px solid #DADADA",
            borderRadius: "4px",
            maxWidth: "320px",
            width: "100%"
        },
        statusBadge: {
            maxWidth: "130px",
            borderRadius: "5px",
            padding: "5px 12px",
            margin: "0",
            background: ""
        },
        processBgYellow: {
            background: "#EFB76D26",
        },
        processTextYellow: {
            color: "#EFB76D",
        },
        processBgOrange: {
            background: "#F2802626",
        },
        processTextOrange: {
            color: "#F28026",
        },
        processBgGreen: {
            background: "#5DA19626",
        },
        processTextGreen: {
            color: "#5DA196",
        },
        processBgRed: {
            background: "#CC605826",
        },
        processTextRed: {
            color: "#CC6058",
        },
        processBgGrary: {
            background: "#82828226",
        },
        processTextGrary: {
            color: "#828282",
        },
        fillBlack: {
            '& > path': {
                fill: '#404349'
            },
            '& g > path': {
                fill: '#404349'
            },
        },
        btnDisabled: {
            '& .Mui-disabled': {
                color: "#FFFFFF !important",
                backgroundColor: "#BABABA !important",
                border: "none !important",
                '& svg > path': {
                    fill: '#FFFFFF !important'
                },
                '& svg > g > path': {
                    fill: '#FFFFFF !important'
                },
            }
        },
        btnNotDisabled: {
            paddingRight: "30px"
        }
    })
    const classes = useStyles();
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const onScroll = (evt) => {
        if (evt !== undefined && evt !== null) {
            if (openMenu) {
                setOpenMenu(false)
            }
            if (openMenus) {
                setOpenMenus(false)
            }
            if (openMenusCompetency) {
                setOpenMenusCompetency(false)
            }
        }
    }

    const dateFormat = (data) => {
        if (data !== undefined && data !== null && data !== "") {
            const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
            const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
                year: '2-digit',
                month: 'short',
            })
            return dateTH
        }
    }
    const dateDayFormat = (data) => {
        if (data !== undefined && data !== null && data !== "") {
            const date = new Date(data.replace(/-/g, "/").replace(/T/g, " "))
            const dateTH = date.toLocaleDateString(i18n.language === "th-TH" ? "th-TH" : "en-GB", {
                year: '2-digit',
                month: 'short',
                day: 'numeric',
            })
            return dateTH
        }
    }
    const setDateWork = () => {
        if (Util.formatData(dataEvaluate?.candidate?.pos_exp, false) !== false && Util.formatData(dataEvaluate?.candidate?.pos_exp, false) !== false) {
            let dataPositionDate = dataEvaluate?.candidate?.pos_exp
            let dataEmpolyeeDate = dataEvaluate?.candidate?.emp_exp
            if (language === "en-US") {
                dataPositionDate = dataPositionDate.replace('y', 'y ')
                dataPositionDate = dataPositionDate.replace('m', 'm ')
                // dataPositionDate = dataPositionDate.replace('d', 'd ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', 'y ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', 'm ')
                // dataEmpolyeeDate = dataEmpolyeeDate.replace('d', 'd ')
                setDatePosition(dataPositionDate)
                setDateEmpoloyee(dataEmpolyeeDate)
            } else {
                dataPositionDate = dataPositionDate.replace('y', ' ปี ')
                dataPositionDate = dataPositionDate.replace('m', ' เดือน ')
                dataPositionDate = dataPositionDate.replace('d', ' วัน')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('y', ' ปี ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('m', ' เดือน ')
                dataEmpolyeeDate = dataEmpolyeeDate.replace('d', ' วัน')
                setDatePosition(dataPositionDate)
                setDateEmpoloyee(dataEmpolyeeDate)
            }

        }
    }

    const handleConfirmDeleteList = async (data) => {
        openConfirmDeleteDialog(false)
        evaluateService.adminDeleteManageEvaluate360({ form_evaluator_id: dataDel?.form_evaluator_id, force_completed: Util.formatData(data, false) }).then(
            (rs) => {
                openSuccessDeleteDialog(true)
            }).catch(() => {

            })
    };

    const handleConfirmResetList = async (data) => {
        openConfirmResetDialog(false)
        evaluateService.reset360({ form_evaluator_id: dataReset?.form_evaluator_id }).then(
            (rs) => {
                openSuccessResetDialog(true)
            }).catch(() => {

            })
    };

    const handleConfirmDeleteDialog = (val) => {
        openConfirmDeleteDialog(val)
    };

    const handleConfirmResetDialog = (val) => {
        openConfirmResetDialog(val)
    };

    const handleConfirmSaveDialog = (val) => {
        openConfirmSaveDialog(val)
    };

    const onDel = (val) => {
        setDataDel(val)
        openConfirmDeleteDialog(true)
    };

    const onReset = (val) => {
        setDataReset(val)
        openConfirmResetDialog(true)
    };

    const handleDirect = () => {
        openSuccessDeleteDialog(false)
        setDataDel({})
        getDetail()
    }

    const handleDirectReset = () => {
        openSuccessResetDialog(false)
        setDataReset({})
        getDetail()
    }

    const handleDirectLaunchForm = () => {
        setOpenSuccessLaunchFormDialog(false)
        getDetail()
    }

    const handleDirectSubmit = () => {
        setOpenSuccessSubmitDialog(false)
        getDetail()
    }

    const onSubmit = () => {
        openConfirmSaveDialog(false)
        evaluateService.submitFormEvaluate360({ form_evaluate_id: serial }).then(
            (rs) => {
                if (Util.formatData(dataEvaluate?.button?.submit, undefined) !== undefined) {
                    setOpenSuccessSubmitDialog(true)
                } else if (Util.formatData(dataEvaluate?.button?.launch, undefined) !== undefined) {
                    setOpenSuccessLaunchFormDialog(true)
                }
            }).catch(() => {

            })
    }

    const onLaunchForm = () => {
        openConfirmSaveDialog(false)
        evaluateService.adminLuanchManageEvaluator({ form_evaluate_id: serial }).then(
            (rs) => {
                if (Util.formatData(dataEvaluate?.button?.submit, undefined) !== undefined) {
                    setOpenSuccessSubmitDialog(true)
                } else if (Util.formatData(dataEvaluate?.button?.launch, undefined) !== undefined) {
                    setOpenSuccessLaunchFormDialog(true)
                }
            }).catch(() => {

            })
    }

    const handleSearch = (event) => {
        setSearch(event.target.value);
    };

    useEffect(() => {
        dataSerachs(mainDatas)
    }, [search]);

    const dataSerachs = async (data) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(data))
        if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            let resultData = []
            for (let index = 0; index <= dataSerach.length - 1; index++) {
                if (Util.formatData(dataSerach[index]?.form_evaluator, []).length > 0) {
                    let filterData = dataSerach[index].form_evaluator.filter((rs, index) => {
                        return Object.keys(rs).some(key => {
                            if (key === 'employee') {
                                let check = false;
                                if (rs[key]?.code !== undefined && rs[key].code.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                                    check = true;
                                }
                                if (rs[key]?.fullname !== undefined && rs[key].fullname.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                                    check = true;
                                }
                                if (rs[key]?.position !== undefined && rs[key].position.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                                    check = true;
                                }
                                if (rs[key]?.organization !== undefined && rs[key].organization.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1) {
                                    check = true;
                                }
                                return check;
                            }

                        });
                    });
                    if (filterData.length > 0) {
                        resultData.push({ ...dataSerach[index], form_evaluator: filterData })
                    }
                }
            }
            result = resultData
        } else {
            result = dataSerach;
        }
        await setData(result);
    };
    return (
        <Box onScroll={onScroll} className="asd" style={{ "max-height": "100%", "overflow-y": "auto" }}>
            <Box id="back-to-top-anchor"> </Box>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/kpi/home')}>{t('label.home')}</span> /  <span style={styles.link} onClick={() => clickLink('/admin/manage-form')}>{t("360Evaluation.label.manageEvalautionForm")}</span> / <span style={styles.end} >{t("label.evaluation360")}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item >
                            <Grid item md={12} xs={12}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <Typography variant="h2" fontWeight={600} color="#404349" fontSize={30} lineHeight={1.495}>
                                        {t("label.evaluation360")}
                                    </Typography>
                                    <Box ml="30px" py="8px" px="20px" sx={{ "max-width": "100%", width: "max-content", "border-radius": "5px", background: dataEvaluate?.current_workflow === "submit" ? "#EFB76D1A" : dataEvaluate?.current_workflow === "review" ? "#F28E2B1A" : dataEvaluate?.current_workflow === "evaluate" ? "#43B6DB1A" : dataEvaluate?.current_workflow === "signoff" ? "#FF71A01A" : dataEvaluate?.current_workflow === "approved" ? "#5DA1961A" : "none" }} >
                                        <Typography fontSize={16} lineHeight="24px" fontWeight={500} color={dataEvaluate?.current_workflow === "submit" ? "#EFB76D" : dataEvaluate?.current_workflow === "review" ? "#F28E2B" : dataEvaluate?.current_workflow === "evaluate" ? "#43B6DB" : dataEvaluate?.current_workflow === "signoff" ? "#FF71A0" : dataEvaluate?.current_workflow === "approved" ? "#5DA196" : "#6B6B6B"} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                            {dataEvaluate?.current_workflow === "submit" ? t('360Evaluation.label.assign') : dataEvaluate?.current_workflow === "review" ? t('360Evaluation.label.review') : dataEvaluate?.current_workflow === "evaluate" ? t('360Evaluation.label.evaluation') : dataEvaluate?.current_workflow === "signoff" ? t('360Evaluation.label.signOff') : dataEvaluate?.current_workflow === "approved" ? t('360Evaluation.label.completed') : t('label.draft')}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Grid container item pb={2} pt={2}>
                                    <Grid item xs sm md lg>
                                        <Card sx={{ height: 1, "box-shadow": "0px 0px 5px rgba(0, 0, 0, 0.1)", "border-radius": "10px" }}>
                                            <CardContent sx={{ padding: "20px", pb: "0px" }}>
                                                <Grid container>
                                                    <Grid item lg={12} xs={12} display="flex" >
                                                        <Grid item xs={6} display="flex" flexDirection="column" pr="15px">
                                                            <Typography variant="h3" fontWeight={600} color="#404349">
                                                                {dataEvaluate?.editor === "evaluator" ?
                                                                    dataEvaluate?.form !== undefined && dataEvaluate?.form !== null ?
                                                                        dataEvaluate?.form?.name
                                                                        : null
                                                                    :
                                                                    t('evaluation.evaluationInformation')
                                                                }
                                                            </Typography>
                                                            <Grid container mt={2} display="flex" alignItems="center">
                                                                <Grid item display="flex" alignItems="center" mr="10px">
                                                                    <FormIcon class={`${classes.fillBlack}`}></FormIcon>
                                                                </Grid>
                                                                <Grid item xs="auto" sm="auto" md="auto" mr={11}>
                                                                    <Box >
                                                                        <Typography fontSize={18} lineHeight={1.1} color="#404349" fontWeight="500">
                                                                            {t('evaluation.formNameManage360')}: <span style={{ fontWeight: "400" }}>{Util.formatData(dataEvaluate?.form?.name, "-")}</span>
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container mt={2} display="flex" alignItems="center">
                                                                <Grid item display="flex" alignItems="center" mr="10px">
                                                                    <CalendarIcon class={`${classes.fillBlack}`}></CalendarIcon>
                                                                </Grid>
                                                                <Grid item xs="auto" sm="auto" md="auto" mr={11}>
                                                                    <Box >
                                                                        <Typography fontSize={18} lineHeight={1.1} color="#404349" fontWeight="500">
                                                                            {t('evaluation.dueDateManage')}: <span style={{ fontWeight: "400" }}>{dateDayFormat(dataEvaluate?.due_date)}</span>
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={6} display="flex" flexDirection="column" pl="15px">
                                                            <Typography fontSize={14} lineHeight="24px" fontWeight={500} color="#AAAAAA">
                                                                {/* {dataEvaluate?.editor === "evaluator" ? */}
                                                                {t('evaluation.candidateProfile')}
                                                                {/* :
                                                                    t('evaluation.myProfile')
                                                                } */}
                                                            </Typography>
                                                            <Grid container display="flex" alignItems="flex-start" flexDirection="row">
                                                                <Grid
                                                                    item
                                                                    display="flex"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                    mr={3}
                                                                >
                                                                    <Avatar
                                                                        src={dataEvaluate?.candidate?.photo}
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            width: 50,
                                                                            height: 50,
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs sm md lg>
                                                                    <Grid container mb="3px" display="flex" alignItems="center" justifyContent="space-between">
                                                                        <Grid item >
                                                                            <Typography fontSize={20} lineHeight="24px" fontWeight={600} color="primary">
                                                                                {Util.formatData(dataEvaluate?.candidate?.fullname, "-")}
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid container>
                                                                        <Grid item xs sm md lg={12} display="flex" alignItems="center" >
                                                                            <Box display="flex" flexDirection="column" justifyContent="center">
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.position`)} placement="top">
                                                                                        <InnovationIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></InnovationIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{Util.formatData(dataEvaluate?.candidate?.position, "-")} ({Util.formatData(datePosition, t('label.dateWork'))})</Typography>
                                                                                </Box>
                                                                                <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.team`)} placement="top">
                                                                                        <TeamIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></TeamIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{Util.formatData(dataEvaluate?.candidate?.organization, "-")}</Typography>
                                                                                </Box>
                                                                                {/* <Box display="flex" alignItems="center" pt="5px">
                                                                                    <BootstrapTooltip title={t(`label.startDate`)} placement="top">
                                                                                        <DateIcon style={{ cursor: "pointer", width: "20px", height: "20px" }}></DateIcon>
                                                                                    </BootstrapTooltip>
                                                                                    <Typography pl="10px" fontSize={18} lineHeight="26.91px" fontWeight={400} color="#404349">{Util.dateDayFormatAdmin(dataEvaluate?.candidate?.candidate_start_at, "-")} ({Util.formatData(dateEmpoloyee, t('label.dateWork'))})</Typography>
                                                                                </Box> */}
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                            <CardContent sx={{ padding: "20px" }}>
                                                <Grid container mt={2}>
                                                    <Grid item xs={12} display="flex">
                                                        {dataEvaluate?.workflow_step?.step !== undefined && dataEvaluate?.workflow_step?.step !== null && dataEvaluate?.workflow_step?.step.length > 0 ?
                                                            <Box sx={{ width: "100%", display: "flex", alignItems: "center", }}>
                                                                {dataEvaluate?.workflow_step?.step.map((loRow, index) => (
                                                                    <>
                                                                        <div
                                                                            style={{
                                                                                maxWidth: "350px",
                                                                                width: "100%",
                                                                                height: "100%",
                                                                                background:
                                                                                    loRow?.is_current === true && loRow?.status === "approve" ?
                                                                                        "#5DA1961A"
                                                                                        : loRow?.is_current === true ?
                                                                                            "#F7B2541A"
                                                                                            : loRow?.status === "approve" ?
                                                                                                "#5DA1961A"
                                                                                                : loRow?.status === "wait" ?
                                                                                                    "#FFFFFF"
                                                                                                    : "#FFFFFF",
                                                                                border:
                                                                                    loRow?.is_current === true && loRow?.status === "approve" ?
                                                                                        "1px solid #5DA196"
                                                                                        : loRow?.is_current === true ?
                                                                                            "1px solid #F7B254"
                                                                                            : loRow?.status === "approve" ?
                                                                                                "1px solid #5DA196"
                                                                                                : loRow?.status === "wait" ?
                                                                                                    "1px solid #DADADA"
                                                                                                    : "1px solid #DADADA",
                                                                                borderRadius: "5px",
                                                                                position: "relative",
                                                                                // paddingBottom: "25px"

                                                                            }}
                                                                        >
                                                                            <Box
                                                                                sx={{ p: 1, display: "flex", alignItems: "start" }}
                                                                            >
                                                                                <Box
                                                                                    mt="4px"
                                                                                    style={{
                                                                                        background:
                                                                                            loRow?.is_current === true && loRow?.status === "approve" ?
                                                                                                "#5DA196"
                                                                                                : loRow?.is_current === true ?
                                                                                                    "#F7B254"
                                                                                                    : loRow?.status === "approve" ?
                                                                                                        "#5DA196"

                                                                                                        : loRow?.status === "wait" ?
                                                                                                            "#FAFAFA" : "#FAFAFA",
                                                                                        border:
                                                                                            loRow?.is_current === true || loRow?.status === "approve" ?
                                                                                                "none" : "1px dashed #C4C4C4",
                                                                                        borderRadius: "50%",
                                                                                        width: "30px",
                                                                                        height: "30px",
                                                                                    }}
                                                                                    sx={{
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                    }}
                                                                                >
                                                                                    {/* <CheckIcon></CheckIcon> */}
                                                                                    {
                                                                                        loRow?.is_current === true && loRow?.status === "approve" ?
                                                                                            <ApprovedIcon></ApprovedIcon>
                                                                                            : loRow?.is_current === true ?
                                                                                                <DraftIcon></DraftIcon>
                                                                                                : loRow?.status === "approve" ?
                                                                                                    <ApprovedIcon></ApprovedIcon>

                                                                                                    : null
                                                                                    }
                                                                                </Box>
                                                                                <Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
                                                                                    <Typography fontSize="18" fontWeight="600"
                                                                                        sx={{
                                                                                            color:
                                                                                                loRow?.is_current === true ||
                                                                                                    loRow?.status === "approve" ?
                                                                                                    "#404349"
                                                                                                    : "#C4C4C4"
                                                                                        }}
                                                                                    >
                                                                                        {loRow?.name}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            {loRow?.type !== "evaluate" ?
                                                                                <Box
                                                                                    sx={{
                                                                                        px: 1,
                                                                                        paddingRight: "0px",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                    }}
                                                                                >
                                                                                    {/* <Box
                                                                                    style={{
                                                                                        width: "37px",
                                                                                    }}
                                                                                ></Box> */}
                                                                                    <Box sx={{ paddingLeft: "30px", ml: 2, display: "flex", alignItems: "baseline", width: "100%", }}>
                                                                                        <Typography variant="h6" fontWeight="400"
                                                                                            sx={{
                                                                                                color:
                                                                                                    loRow?.is_current === true ||
                                                                                                        loRow?.status === "approve" ?
                                                                                                        "#404349"
                                                                                                        : "#C4C4C4"
                                                                                            }}>
                                                                                            {t('label.by')}<span>&nbsp;</span>
                                                                                        </Typography>
                                                                                        <Box sx={{ width: "100%", }}>
                                                                                            {loRow?.options?.assignee !== undefined && loRow?.options?.assignee !== null && loRow?.options?.assignee.length > 0 ?
                                                                                                loRow?.options?.assignee.map((item) => (
                                                                                                    <Box sx={{ width: "calc(100% - 44px)", display: "flex", alignItems: "center", justifyContent: "space-between", position: "relative", }}>
                                                                                                        <Typography variant="h6" fontWeight="400"
                                                                                                            sx={{
                                                                                                                width: item?.proxy_by !== undefined && item?.proxy_by !== null && item?.proxy_by !== "" ? "calc(100% - 25px)" : "calc(100% - 10px)",
                                                                                                                textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap",
                                                                                                                color:
                                                                                                                    loRow?.is_current === true ||
                                                                                                                        loRow?.status === "approve" ?
                                                                                                                        "#404349"
                                                                                                                        : "#C4C4C4"
                                                                                                            }}>
                                                                                                            {item.assignee}
                                                                                                        </Typography>
                                                                                                        {item?.proxy_by !== undefined && item?.proxy_by !== null && item?.proxy_by !== "" ?
                                                                                                            <Box style={{ position: "absolute", right: 0, top: 0, margin: "2px 6px 6px 0px", }}>
                                                                                                                <div style={{ width: "max-content" }}>
                                                                                                                    <BootstrapTooltip
                                                                                                                        placement="top"
                                                                                                                        arrow
                                                                                                                        title={t('label.proxyBy') + "" + Util.formatData(item?.proxy_by, "-")}
                                                                                                                    >
                                                                                                                        <InfoIcon style={{ cursor: "pointer" }} />
                                                                                                                    </BootstrapTooltip>
                                                                                                                    {/* <div className='tooltip' onClick={e => handleTooltipOpen("1")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                                                                                                </div>
                                                                                                            </Box> : null}
                                                                                                    </Box>
                                                                                                ))
                                                                                                :
                                                                                                <Typography variant="h6" fontWeight="400"
                                                                                                    sx={{
                                                                                                        color:
                                                                                                            loRow?.is_current === true ||
                                                                                                                loRow?.status === "approve" ?
                                                                                                                "#404349"
                                                                                                                : "#C4C4C4"
                                                                                                    }}>
                                                                                                    {"-"}
                                                                                                </Typography>
                                                                                            }
                                                                                        </Box>
                                                                                    </Box>
                                                                                </Box>
                                                                                :
                                                                                null
                                                                            }
                                                                            <Box
                                                                                sx={{
                                                                                    px: 1,
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                {/* <Box
                                                                                    style={{
                                                                                        width: "30px",
                                                                                    }}
                                                                                ></Box> */}
                                                                                <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                                                                    <Typography variant="h6" fontWeight="400"
                                                                                        sx={{
                                                                                            color:
                                                                                                loRow?.is_current === true ||
                                                                                                    loRow?.status === "approve" ?
                                                                                                    "#404349"
                                                                                                    : "#C4C4C4"
                                                                                        }}>
                                                                                        {/* {t('label.formStatus')}: {Util.formatData(loRow?.status, "Not Started")} */}
                                                                                        {t('label.formStatus')}: {loRow?.is_current === true && loRow?.status === "approve" ? t('label.completed') : loRow?.is_current === true ? t('label.inProgress') : loRow?.status === "approve" ? t('label.completed') : t('label.notStarted')}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            <Box
                                                                                sx={{
                                                                                    px: 1,
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                {/* <Box
                                                                                    style={{
                                                                                        width: "30px",
                                                                                    }}
                                                                                ></Box> */}
                                                                                <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                                                                    <Typography variant="h6" fontWeight="400"
                                                                                        sx={{
                                                                                            color:
                                                                                                loRow?.is_current === true ||
                                                                                                    loRow?.status === "approve" ?
                                                                                                    "#404349"
                                                                                                    : "#C4C4C4"
                                                                                        }}>
                                                                                        {t('evaluation.submittedDate')}: {Util.formatData(dateDayFormat(loRow?.update_at), "-")}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            {Util.formatData(loRow?.start_date, false) !== false ?
                                                                                <Box
                                                                                    sx={{
                                                                                        px: 1,
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                    }}
                                                                                >
                                                                                    <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                                                                        <Typography variant="h6" fontWeight="400"
                                                                                            sx={{
                                                                                                color:
                                                                                                    loRow?.is_current === true ||
                                                                                                        loRow?.status === "approve" ?
                                                                                                        "#404349"
                                                                                                        : "#C4C4C4"
                                                                                            }}>
                                                                                            {t('evaluation.startDate')}: {dateDayFormat(loRow?.start_date)}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                                : null}
                                                                            <Box
                                                                                sx={{
                                                                                    px: 1,
                                                                                    pb: 1,
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                }}
                                                                            >
                                                                                {/* <Box
                                                                                    style={{
                                                                                        width: "30px",
                                                                                    }}
                                                                                ></Box> */}
                                                                                <Box sx={{ paddingLeft: "30px", ml: 2 }}>
                                                                                    <Typography variant="h6" fontWeight="400"
                                                                                        sx={{
                                                                                            color:
                                                                                                loRow?.is_current === true ||
                                                                                                    loRow?.status === "approve" ?
                                                                                                    "#404349"
                                                                                                    : "#C4C4C4"
                                                                                        }}>
                                                                                        {t('evaluation.dueDate')}: {Util.formatData(dateDayFormat(loRow?.end_date), "-")}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                            <Box
                                                                                style={{
                                                                                    position: "absolute",
                                                                                    right: 0,
                                                                                    top: 0,
                                                                                    margin: 6,
                                                                                }}
                                                                            >
                                                                                <div style={{ width: "max-content" }}>
                                                                                    <BootstrapTooltip
                                                                                        placement="top"
                                                                                        arrow
                                                                                        title={Util.formatData(loRow?.tooltip, "-")}
                                                                                    >
                                                                                        <InfoIcon style={{ cursor: "pointer" }} />
                                                                                    </BootstrapTooltip>
                                                                                    {/* <div className='tooltip' onClick={e => handleTooltipOpen("1")} style={{ cursor: "pointer", width: "14px", height: "100%", position: "absolute", top: 0 }}></div> */}
                                                                                </div>
                                                                            </Box>
                                                                        </div>
                                                                        {/* connector */}
                                                                        < Box
                                                                            sx={{
                                                                                borderTop: "3px dashed #E5E5E5",
                                                                                width: "100%",
                                                                                maxWidth: "65px",
                                                                                "&:last-child": {
                                                                                    borderTop: "none",
                                                                                    width: "0px"
                                                                                }
                                                                            }}
                                                                        ></Box>
                                                                    </>
                                                                ))}
                                                            </Box>
                                                            : null
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sx={{ paddingTop: "14px !important" }}>
                            <Box >
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <TextField
                                        id="input-with-icon-textfield"
                                        fullWidth
                                        placeholder={t('competencyMapping.search')}
                                        size="small"
                                        sx={{ background: "#fff", width: "400px", "input": { padding: "11px 14px" } }}
                                        className="searchTextField-h40"
                                        value={search}
                                        onChange={handleSearch}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search style={{ color: "#C4C4C4" }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                                {Datas.length > 0 ? Datas.map((rs) =>
                                    <Box >
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Typography fontWeight="600" fontSize={24} lineHeight="35.88px" py="23px" color="#404349">
                                                {rs?.type === "self" ? t('evaluation.manageSelf') : rs?.type === "superior" ? t('evaluation.manageSuperior') : rs?.type === "subordinate" ? t('evaluation.manageSubordinate') : rs?.type === "peer" ? t('evaluation.managePeer') : null} {Util.formatData(rs?.selected?.min, false) !== false ? <span style={{ color: rs?.selected?.current >= rs?.selected?.min ? "#5DA196" : "#CC6058" }}> ({rs?.selected?.current}/{rs?.selected?.min})</span> : null}
                                            </Typography>
                                            {rs?.options?.can_add === true ?
                                                <Button size="small" variant="outlined" sx={{ height: "42px" }} color="black" className={classes.outlineGrayBtn} onClick={() => navigate("/admin/360evaluation/add-evluator/" + rs?.type, { replace: false, state: { type: "admin", data: Util.formatData(dataEvaluate, {}), dataEmployee: Util.formatData(rs, []) } })}>
                                                    <Box
                                                        display="flex"
                                                        alignItems="center"
                                                    >
                                                        <PlusIcon className={classes.plusSvg} />
                                                        <Typography sx={{ marginLeft: "3px", color: '#404349!important', fontWeight: "500" }}>
                                                            {t('label.add')}
                                                        </Typography>
                                                    </Box>
                                                </Button>
                                                : null}
                                        </Box>
                                        <Box sx={{ borderRadius: "10px", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", background: "#fff" }} p="30px">
                                            <Box px="20px" display="flex">
                                                <Box width="calc(32% - 20px)" pr="20px">
                                                    <Typography fontWeight="500" color="#A0A0A0" fontSize={16} lineHeight="23.92px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                        {t('evaluation.evaluator')}
                                                    </Typography>
                                                </Box>
                                                <Box width="calc(24.80%  - 20px)" pr="20px">
                                                    <Typography fontWeight="500" color="#A0A0A0" fontSize={16} lineHeight="23.92px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                        {t('label.position')}
                                                    </Typography>
                                                </Box>
                                                <Box width="calc(12.80%  - 20px)" pr="20px">
                                                    <Typography fontWeight="500" color="#A0A0A0" fontSize={16} lineHeight="23.92px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                        {t('label.addedBy')}
                                                    </Typography>
                                                </Box>
                                                <Box width="calc(17.50%  - 20px)" pr="20px">
                                                    {rs?.options?.hide_status !== true ?
                                                        <Typography fontWeight="500" color="#A0A0A0" fontSize={16} lineHeight="23.92px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                            {t('label.evaluateProgress')}
                                                        </Typography>
                                                        : null}
                                                </Box>
                                                <Box width="calc(12.90%  - 20px)" pr="20px">
                                                    {rs?.options?.hide_status !== true ?
                                                        <Typography fontWeight="500" color="#A0A0A0" fontSize={16} lineHeight="23.92px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                            {t('mygoal.label.lastUpdate')}
                                                        </Typography>
                                                        : null}
                                                </Box>
                                                <Box width="100px">
                                                    {rs?.type !== "self" && rs?.options?.hide_status !== true ?
                                                        dataEvaluate?.current_workflow === "approved" || dataEvaluate?.current_workflow === "signoff" ? null :
                                                            <Typography fontWeight="500" color="#A0A0A0" fontSize={16} lineHeight="23.92px" textAlign="center">
                                                                {t('calibration.label.action')}
                                                            </Typography>
                                                        : null}
                                                </Box>
                                            </Box>
                                            <Divider sx={{ pt: "15px" }} />
                                            {Util.formatData(rs?.form_evaluator, []).length > 0 ? rs?.form_evaluator.map((low) =>
                                                <Box>
                                                    <Box px="20px" display="flex" height="95px" alignItems="center">
                                                        <Box width="calc(32%  - 20px)" pr="20px">
                                                            <Box
                                                                display="flex"
                                                                sx={{
                                                                    flexFlow: "column",
                                                                    textAlign: "left",
                                                                    // marginLeft: 2,
                                                                    position: "relative",
                                                                }}
                                                            >
                                                                {Util.formatData(low?.employee?.serial, false) !== false ?
                                                                    <Box display="flex" alignItems="center">
                                                                        <Avatar
                                                                            src={Util.formatData(low?.employee?.photo, "")}
                                                                            sx={{
                                                                                cursor: "pointer",
                                                                                width: 40,
                                                                                height: 40,
                                                                            }}
                                                                        />
                                                                        <Box pl="10px" sx={{ maxWidth: "calc(100% - 40px)" }}>
                                                                            <Typography
                                                                                variant="h4"
                                                                                fontWeight={400}
                                                                                fontSize={18}
                                                                                lineHeight="27px"
                                                                                color="#404349"
                                                                                sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}
                                                                            >
                                                                                {Util.formatData(low?.employee?.fullname, "")}
                                                                            </Typography>
                                                                            <Typography fontSize="14px" color="#AAAAAA" lineHeight="21px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                {Util.formatData(low?.employee?.code, "")}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                    :
                                                                    <Box display="flex" alignItems="center">
                                                                        <Avatar
                                                                            src={""}
                                                                            sx={{
                                                                                cursor: "pointer",
                                                                                width: 40,
                                                                                height: 40,
                                                                            }}
                                                                        />
                                                                        <Box pl="10px" sx={{ maxWidth: "calc(100% - 40px)" }}>
                                                                            <Typography
                                                                                variant="h4"
                                                                                fontWeight={400}
                                                                                fontSize={18}
                                                                                lineHeight="27px"
                                                                                color="#404349"
                                                                                sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}
                                                                            >
                                                                                {t('360Evaluation.label.anonymous')}
                                                                            </Typography>
                                                                            <Typography fontSize="14px" color="#AAAAAA" lineHeight="21px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                -
                                                                            </Typography>
                                                                        </Box>
                                                                    </Box>
                                                                }
                                                            </Box>
                                                        </Box>
                                                        <Box width="calc(24.80%  - 20px)" pr="20px">
                                                            {Util.formatData(low?.employee?.serial, false) !== false ?
                                                                <Box>
                                                                    <Typography variant="h4" fontWeight={400} fontSize={16} lineHeight="24px" color="#404349" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{Util.formatData(low?.employee?.position, "")}</Typography>
                                                                    <Typography fontSize="14px" color="#AAAAAA" lineHeight="21px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{Util.formatData(low?.employee?.organization, "")}</Typography>
                                                                </Box>
                                                                :
                                                                <Box>
                                                                    <Typography variant="h4" fontWeight={400} fontSize={16} lineHeight="24px" color="#404349" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>-</Typography>
                                                                    <Typography fontSize="14px" color="#AAAAAA" lineHeight="21px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>-</Typography>
                                                                </Box>
                                                            }
                                                        </Box>
                                                        <Box width="calc(12.80%  - 20px)" pr="20px">
                                                            <Typography
                                                                variant="h4"
                                                                fontWeight={400}
                                                                fontSize={16}
                                                                lineHeight="24px"
                                                                color="#404349"
                                                                sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}
                                                            >
                                                                {Util.formatData(low?.added_by?.fullname, "")}
                                                            </Typography>
                                                        </Box>
                                                        <Box width="calc(17.50%  - 20px)" pr="20px">
                                                            {rs?.options?.hide_status !== true ?
                                                                <Box py="8px" px="20px" sx={{ "max-width": "170px", width: "100%", border: low?.status === "draft" ? "1px solid #DADADA" : "none", "border-radius": "5px", background: low?.status === "pending" ? "#EFB76D1A" : low?.status === "approved" ? "#5DA1961A" : "none" }} >
                                                                    <Typography fontSize={16} lineHeight="24px" fontWeight={500} color={low?.status === "pending" ? "#EFB76D" : low?.status === "approved" ? "#5DA196" : "#DADADA"} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                        {low?.status === "draft" ? t('360Evaluation.label.draft') : low?.status === "pending" ? t('360Evaluation.label.inProgress') : low?.status === "approved" ? t('360Evaluation.label.completed') : null}
                                                                    </Typography>
                                                                </Box>
                                                                : null}
                                                        </Box>
                                                        <Box width="calc(12.90%  - 20px)" pr="20px">
                                                            {rs?.options?.hide_status !== true ?
                                                                <Box>
                                                                    <Typography variant="h4" fontWeight={400} fontSize={16} lineHeight="24px" color="#404349" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{dateDayFormat(low?.last_update)}</Typography>
                                                                    <Typography fontSize="14px" color="#AAAAAA" lineHeight="21px" sx={{ whiteSpace: "nowrap", width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{Util.formatData(low?.last_update, false) !== false ? Util.timeFormat(low?.last_update) : ""}</Typography>
                                                                </Box>
                                                                : null}
                                                        </Box>
                                                        <Box width="100px" sx={{ textAlign: "center" }}>
                                                            <BootstrapTooltip title="Delete" placement="top">
                                                                <IconButton onClick={e => onDel(low)} color="primary" aria-label="delete" component="label" sx={low?.action?.delete ? {} : { opacity: "0.5" }} disabled={!low?.action?.delete} >
                                                                    <TrashIcon className={low?.status === "approved" ? classes.trashIconDisabledSvg : classes.trashIconSvg} />
                                                                </IconButton>
                                                            </BootstrapTooltip>
                                                            <BootstrapTooltip title="Restart" placement="top">
                                                                <IconButton onClick={e => onReset(low)} color="primary" aria-label="Refresh" component="label" sx={low?.action?.restart ? {} : { opacity: "0.5" }} disabled={!low?.action?.restart} >
                                                                    <Refresh className={low?.status !== "approved" ? classes.trashIconDisabledSvg : classes.trashIconSvg} />
                                                                </IconButton>
                                                            </BootstrapTooltip>
                                                        </Box>
                                                    </Box>
                                                    <Divider />
                                                </Box>
                                            )
                                                :
                                                rs?.options?.can_add === true ?
                                                    <Box sx={{ "padding-top": "10px", "text-align": "center", }}>
                                                        <Nodata />
                                                        <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                            {rs?.type === "self" ? t('360Evaluation.label.noSelf') : rs?.type === "peer" ? t('360Evaluation.label.noPeer') : rs?.type === "subordinate" ? t('360Evaluation.label.noSubordinate') : rs?.type === "superior" ? t('360Evaluation.label.noSuperior') : null}
                                                        </Typography>
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="23.92px" >
                                                            {rs?.type === "self" ? t('360Evaluation.label.pleaseAddSelf') : rs?.type === "peer" ? t('360Evaluation.label.pleaseAddPeer') : rs?.type === "subordinate" ? t('360Evaluation.label.pleaseAddSubordinate') : rs?.type === "superior" ? t('360Evaluation.label.pleaseAddSuperior') : null}
                                                        </Typography>
                                                    </Box>
                                                    :
                                                    <Box sx={{ "padding-top": "10px", "text-align": "center", }}>
                                                        <NodataPlsAdd />
                                                        <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="23.92px" >
                                                            {t('360Evaluation.label.noData')}
                                                        </Typography>
                                                    </Box>
                                            }
                                        </Box>
                                    </Box>
                                )
                                    : null}
                            </Box>
                        </Grid>
                        <Grid item xs={12} sx={{ paddingTop: "23px !important" }}>
                            <Box pl="15px" mb="50px">
                                <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                    <Button color="black" variant="outlined" onClick={() => clickLink('/admin/manage-form')}>
                                        <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="29px" fontWeight="500" color="#6B6B6B">
                                            {t('label.back')}
                                        </Typography>
                                    </Button>
                                    {Util.formatData(dataEvaluate?.button?.submit, undefined) !== undefined || Util.formatData(dataEvaluate?.button?.launch, undefined) !== undefined ?
                                        <Button color="primary" variant="contained" sx={{ ml: "35px" }} onClick={e => openConfirmSaveDialog(true)} disabled={Util.formatData(dataEvaluate?.button?.submit, undefined) !== undefined ? !dataEvaluate?.button?.submit : Util.formatData(dataEvaluate?.button?.launch, undefined) !== undefined ? !dataEvaluate?.button?.launch : true}>
                                            <LaunchFormIcon /> <Typography sx={{ textTransform: "none" }} pl="10px" fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">{Util.formatData(dataEvaluate?.button?.submit, undefined) !== undefined ? t('360Evaluation.label.submit') : Util.formatData(dataEvaluate?.button?.launch, undefined) !== undefined ? t('360Evaluation.label.launchForm') : null}</Typography>
                                        </Button>
                                        : null}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container >
            </Box >
            <SimpleDialog
                open={isSuccessDeleteDialogOpen}
                setValue={openSuccessDeleteDialog}
                doDirect={() => handleDirect()}
                page={true}
                text={`${t('360Evaluation.label.deleted')} “${dataDel?.employee?.fullname}”`}
            />
            <SimpleDialog
                open={isSuccessResetDialogOpen}
                setValue={openSuccessResetDialog}
                doDirect={() => handleDirectReset()}
                page={true}
                text={t('360Evaluation.label.restarted')}
            />
            <SimpleDialog
                open={openSuccessLaunchFormDialog}
                setValue={setOpenSuccessLaunchFormDialog}
                doDirect={() => handleDirectLaunchForm()}
                page={true}
                text={t('360Evaluation.label.formWasLaunced')}
            />
            <SimpleDialog
                open={openSuccessSubmitDialog}
                setValue={setOpenSuccessSubmitDialog}
                doDirect={() => handleDirectSubmit()}
                page={true}
                text={t('360Evaluation.label.formWasSubmitted')}
            />
            <ConfirmDialog open={isConfirmDeleteDialogOpen} doConfirmV2={handleConfirmDeleteList} doConfirm={handleConfirmDeleteList} confirmNext={dataEvaluate?.progress?.inprogress === 1 || dataEvaluate?.progress?.inprogress === "1"} setValue={handleConfirmDeleteDialog} title={t('label.confirmationofDeletion')} text={`${dataEvaluate?.progress?.inprogress === 1 || dataEvaluate?.progress?.inprogress === "1" ? t('360Evaluation.label.lastEvaluator') : t('admin.label.confirmDeleteCalibrationSessionText')} “${dataDel?.employee?.fullname}”?`} />
            <ConfirmDialog open={isConfirmResetDialogOpen} warning={true} doConfirmV2={handleConfirmResetList} doConfirm={handleConfirmResetList} setValue={handleConfirmResetDialog} title={t('label.confirmationofRestart')} text={`${t('label.restartFormOf')} “${dataReset?.employee?.fullname}”?`} />
            <ConfirmDialog open={isConfirmSaveDialogOpen} warning={true} doConfirm={Util.formatData(dataEvaluate?.button?.submit, undefined) !== undefined ? onSubmit : Util.formatData(dataEvaluate?.button?.launch, undefined) !== undefined ? onLaunchForm : true} setValue={handleConfirmSaveDialog} title={Util.formatData(dataEvaluate?.button?.submit, undefined) !== undefined ? t('360Evaluation.label.confirmationOfSubmit') : Util.formatData(dataEvaluate?.button?.launch, undefined) !== undefined ? t('360Evaluation.label.confirmationOfLaunch') : ""} text={Util.formatData(dataEvaluate?.button?.submit, undefined) !== undefined ? `${t('360Evaluation.label.sureToSubmit')} “${dataEvaluate?.form?.name}” ${i18n.language === "th-TH" ? "" : "form"} ?` : Util.formatData(dataEvaluate?.button?.launch, undefined) !== undefined ? `${t('360Evaluation.label.sureToLaunch')} “${dataEvaluate?.form?.name}” ${i18n.language === "th-TH" ? "" : "form"} ?` : ""} />
            {Util.ScrollToTop()}
        </Box >
    )
};
export default Manage360Evaluation;
